import { render } from "./AmendBooking.vue?vue&type=template&id=31cca432&scoped=true&lang=pug"
import script from "./AmendBooking.vue?vue&type=script&lang=ts"
export * from "./AmendBooking.vue?vue&type=script&lang=ts"

import "./AmendBooking.vue?vue&type=style&index=0&id=31cca432&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-31cca432"

export default script